export default {"src":"/_next/static/media/dog-blue-red.090165b6.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};